angular.
module("dx.webapp.exams").
factory("dxExamsFilters", function examsFiltersService(
	examStatus
) {
	"use strict";

	function scheduledExamsFilter(exam) {
		return exam.examStatus === examStatus.NOT_STARTED || exam.examStatus === examStatus.PLANNED;
	}

	function ongoingExamsFilter(exam) {
		return exam.examStatus === examStatus.ACTIVE;
	}

	function ungradedExamsFilter(exam) {
		return exam.examStatus === examStatus.NOT_GRADED;
	}

	function gradedExamsFilter(exam) {
		return exam.examStatus === examStatus.GRADED;
	}

	function publishedExamsFilter(exam) {
		return exam.examStatus === examStatus.PUBLISHED;
	}

	return {
		scheduledExamsFilter: scheduledExamsFilter,
		ongoingExamsFilter: ongoingExamsFilter,
		ungradedExamsFilter: ungradedExamsFilter,
		gradedExamsFilter: gradedExamsFilter,
		publishedExamsFilter: publishedExamsFilter,
	};
});
